import React from "react";

import ProductImage from "./ProductImage";
import noeImage from "assets/images/home/productNeo.webp";
import aiTech from "assets/images/home/advancedAi.webp";
import light from "assets/images/home/lightAndMighty.webp";
import battery from "assets/images/home/battery.webp";
import useScreenMobile from "hooks/useScreenMobile";

import "./productScroll.scss";

const ProductScroll = () => {
  const isMobile = useScreenMobile({ size: 767 });
  return isMobile ? (
    <section className="container productScrollContainer">
      <div className="productImage"></div>
      <div className="noeImage  placeTop">
        <ProductImage image={noeImage} name="Sleek and Stylish" />
      </div>
      <div className="aiTech placeTop">
        <ProductImage image={aiTech} name="Advanced AI Tech" />
      </div>
      <div className="light placeTop">
        <ProductImage image={light} name="Light & Mighty" />
      </div>
      <div className="battery placeTop">
        <ProductImage image={battery} name="Lasting Battery" />
      </div>
    </section>
  ) : (
    <section className="container productScrollContainer">
      <div className="productImage"></div>
      <div className="noeImage placeTop">
        <ProductImage image={noeImage} name="Sleek and Stylish" />
      </div>
      <div className="aiTech placeTop">
        <ProductImage image={aiTech} name="Advanced AI Tech" />
      </div>
      <div className="light placeTop">
        <ProductImage image={light} name="Light & Mighty" />
      </div>
      <div className="battery placeTop">
        <ProductImage image={battery} name="Lasting Battery" />
      </div>
    </section>
  );
};

export default ProductScroll;
